const input = document.getElementById('email_input');
const button = document.getElementById('subscribe-btn');
const errorMessage = document.querySelector('span.subscribe-form__error');
const axios = require('axios');

const URL_SEND_EMAIL = 'https://itpixie.herokuapp.com/emails/send';

const validateEmailForm = e => {
  if (
    /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(
      input.value,
    )
  ) {
    button.disabled = false;
    errorMessage.style.display = 'none';
  } else {
    button.disabled = true;
  }
};

const showValidationErrorMessage = e => {
  if (!errorMessage) return;
  if (
    !/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(
      input.value,
    )
  ) {
    errorMessage.style.display = 'block';
  }
};

if (input) {
  input.addEventListener('change', showValidationErrorMessage);
  input.addEventListener('input', validateEmailForm);
}

//contacts us form
const validateSubmit = async e => {
  e.preventDefault();

  const nameRegex = /[0-9a-zA-Z]{5,}/;
  const emailRegex = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
  const textRegex = /[0-9a-zA-Z]{5,}/;
  let url = new URL(document.location);

  const emailWarning = document.querySelector('.emailWarning');
  const nameWarning = document.querySelector('.nameWarning');
  const textWarning = document.querySelector('.textWarning');
  const cameFrom = url.searchParams.get('from');

  const email = e.currentTarget.email.value;
  const firstName = e.currentTarget.first_name.value;
  const lastName = e.currentTarget.last_name.value;
  const company = e.currentTarget.company.value;
  const number = e.currentTarget.number.value;
  const message = e.currentTarget.message.value;
  const design = e.currentTarget.design.checked && e.currentTarget.design.value;
  const development =
    e.currentTarget.development.checked && e.currentTarget.development.value;
  const seo = e.currentTarget.seo.checked && e.currentTarget.seo.value;

  const body = {
    email,
    firstName,
    lastName,
    company,
    number,
    message,
    seo,
    development,
    design,
    cameFrom,
  };
  if (nameRegex.test(firstName)) {
    nameWarning.style.display = 'none';
  } else {
    nameWarning.style.display = 'block';
    return;
  }

  if (emailRegex.test(email)) {
    emailWarning.style.display = 'none';
  } else {
    emailWarning.style.display = 'block';
    return;
  }

  if (textRegex.test(firstName)) {
    textWarning.style.display = 'none';
  } else {
    textWarning.style.display = 'block';
    return;
  }

  try {
    await axios.post(URL_SEND_EMAIL, body);
    const contactUsFormSubmited = document.querySelector(
      '.contact-us-form__submited',
    );
    contactUsFormSubmited.style.display = 'flex';
    contactUsFormSubmited.style.height = '90%';
    contactUsFormSubmited.style.transition = 'height 3s';
    contactUsFormSubmited.style.visibility = 'visible';
    contactUsForm.style.visibility = 'hidden';
  } catch (error) {
    console.log(error);
  }
};

contactUsForm = document.querySelector('.contact-us-form');
contactUsForm && contactUsForm.addEventListener('submit', validateSubmit);

//fill text text field from params
(function () {
  let url = new URL(document.location);
  let order = url.searchParams.get('order');

  if (order) {
    contactUsForm.message.value = `Hello! I'm interested in the ${
      order.charAt(0).toUpperCase() + order.slice(1)
    } package`;
  }
})();
